<template>
    <van-dialog v-model="isVisibility">
        <div class="diyModal">
            <div class="arrow-wrap"><img class="arrow"
                    src="static/image/guide-arrow.png" /></div>
            <div class="desc">
                点击右上角
            </div>
            <div class="desc">
                选择【浏览器】打开
            </div>
        </div>
    </van-dialog>
</template>
<script>
import { Dialog } from 'vant';
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      isVisibility: false,
    };
  },
  methods: {
    openModel() {
      this.isVisibility = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.van-dialog {
  width: 100%;
  overflow: initial;
  background-color: transparent;
  top: 0;
  left: 0;
  transform: none;
  /deep/ .van-dialog__content {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100vh;
    .diyModal {
      margin-left: 19px;
      width: 100vw;
      height: 100vh;
      margin-left: 65px;
      .arrow-wrap {
        position: relative;
        width: 98px;
        height: 98px;
        margin-bottom: 5px;
        width: 100vw;
        .arrow {
          width: 98px;
          height: 98px;
          position: absolute;
          right: 75px;
          top: 0;
        }
      }
      .desc {
        font-family: HYQiHei-GZS;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        font-weight: 400;
        margin-bottom: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/page/vibrantRubikCube/scanGameWallLocate/guideDialog.vue